import axios from 'axios';

import {
  GET_NOTIFICATION_REQUEST,
  GET_NOTIFICATION_SUCCESS,
  GET_NOTIFICATION_FAIL,
} from '../../reducers/Notification/getNotications';

const isNotificationRead = (item) =>
  Boolean(item?.readAt) ||
  String(item?.status || '').toUpperCase() === 'READ' ||
  item?.read === true;

const normalizeNotification = (item) => ({
  ...item,
  message: item?.body || item?.title || '',
  read: isNotificationRead(item),
});

export const allNotification =
  (loginUser = '', type = '', options = {}) =>
    async (dispatch) => {
      try {
        dispatch({ type: GET_NOTIFICATION_REQUEST.toString() });
        const page = options?.page || 1;
        const limit = options?.limit || 100;
        const receiverId = options?.receiverId || loginUser;
        const fallbackReceiverId = options?.fallbackReceiverId || '';

        const receiverParam = receiverId
          ? `&receiverId=${encodeURIComponent(receiverId)}`
          : '';
        const statusParam = options?.status
          ? `&status=${encodeURIComponent(options.status)}`
          : '';
        const link = `v2/notifications?page=${page}&pageSize=${limit}${receiverParam}${statusParam}`;

        const [{ data }, unreadRes] = await Promise.all([
          axios.get(link, { withCredentials: true }),
          axios
            .get(
              `v2/notifications/unread-count${
                receiverId ? `?receiverId=${encodeURIComponent(receiverId)}` : ''
              }`,
              { withCredentials: true },
            )
            .catch(() => null),
        ]);

        let items = Array.isArray(data?.data?.items) ? data.data.items : [];

        // Legacy path: if the preferred company id has no rows, retry the user id.
        // Backend now ORs both ids when the session is present, so this is mainly
        // for older APIs / explicit receiver-only queries.
        if (
          items.length === 0 &&
          fallbackReceiverId &&
          fallbackReceiverId !== receiverId
        ) {
          const fallbackLink = `v2/notifications?page=${page}&pageSize=${limit}&receiverId=${encodeURIComponent(
            fallbackReceiverId,
          )}`;
          const fallback = await axios.get(fallbackLink, { withCredentials: true });
          items = Array.isArray(fallback?.data?.data?.items)
            ? fallback.data.data.items
            : [];
          if (fallback?.data?.data) {
            data.data = fallback.data.data;
          }
        }

        const notifications = items.map(normalizeNotification);
        const pageUnread = notifications.filter((n) => n.read === false).length;
        const serverUnread = Number(unreadRes?.data?.data?.count);
        const unreadCount = Number.isFinite(serverUnread)
          ? serverUnread
          : pageUnread;

        const normalizedPayload = {
          success: Boolean(data?.success),
          notifications,
          pagination: {
            page: Number(data?.data?.page || page),
            limit: Number(data?.data?.pageSize || limit),
            totalCount: Number(data?.data?.total || notifications.length),
            totalPages: Number(data?.data?.totalPages || 1),
            hasNextPage:
              Number(data?.data?.page || page) <
              Number(data?.data?.totalPages || 1),
          },
          unreadCount,
        };

        dispatch({
          type: GET_NOTIFICATION_SUCCESS.toString(),
          payload: normalizedPayload,
        });
      } catch (error) {
        dispatch({
          type: GET_NOTIFICATION_FAIL.toString(),
          payload:
            error?.response?.data?.message || 'Failed to fetch notifications',
        });
      }
    };
